import { Exception } from '../../../../core/logic/exception';

export class EstimateNotFoundException extends Exception<never> {
  constructor() {
    super('Devis non trouvée');
  }
}
